import { Route } from "react-router-dom";
import { AppRoutes, guestPath } from "@/infra/router";
import GuestRoute from "@/infra/router/GuestRoute";
import { GUEST_ONBOARDING_ROUTES } from "@/pages/onboarding/routes";
import { LoginPage } from "@/pages/LoginPage";

export const GUEST_ROUTES = [
    <Route key="guest" element={<GuestRoute />}>
        <Route path={guestPath(AppRoutes.Login)} element={<LoginPage />} />
        {GUEST_ONBOARDING_ROUTES}
    </Route>,
];

